import { EnqueteStatusListPage } from '../pages/EnqueteStatusListPage';

//ユーザのロールを確認し、ページを表示するかどうか決める
export const enqueteStatusRoute = {
  path: 'enquete-status',
  children: [
    {
      path: '',
      element: <EnqueteStatusListPage />,
    },
    {
      path: ':id',
      element: <EnqueteStatusListPage />,
    },
  ],
};
